export function distributeListInColumns<TypeList>(
  list: TypeList[],
  columnsCount: number
): TypeList[][] {
  const newArrayColumns = Array.from(
    { length: columnsCount },
    () => [] as TypeList[]
  )

  list.forEach((item, index) => {
    const columnIndex = index % columnsCount

    newArrayColumns?.[columnIndex]?.push(item)
  })

  return newArrayColumns
}
